export default {
      id: "i-submit-usage",
      viewBox: "0 0 22 18",
      url: __webpack_public_path__ + "img/sprite.svg#i-submit",
      toString: function () {
        return this.url;
      }
    }